'use client';

import { Fullstory } from '@fullstory/browser';

import { useEffect } from 'react';

import { isProd } from '../../common/util/environmentConfig';
import { useFullstoryReady } from './useFullStoryReady';

export function useLogFullstorySession(): void {
	const [ready] = useFullstoryReady();

	useEffect(() => {
		if (!ready) {
			return;
		}

		if (!isProd) {
			const sessionUrl = Fullstory('getSession', { format: 'url' });
			console.log(`Fullstory session: ${sessionUrl}`);
		}
	}, [ready]);
}
